<template>
  <div id="views-page1">
    <!-- 头部 -->
    <HeaderTitle :title="title" :navIndex="1"></HeaderTitle>
    <!-- 内容 -->
    <div class="content">
      <!-- 左 -->
      <div class="left">
        <!-- 环境数据监测 -->
        <div class="left-one">
          <div class="title" style="padding: 10px 0 0 40px !important">
            环境数据监测
          </div>
          <div class="left-one-list">
            <div
              class="left-one-list-sj"
              v-for="(item, index) in huanjingList"
              :key="index"
            >
              <span class="left-one-list-sj-tp">
                <img :src="item.icon" alt="" />
              </span>
              <div style="width: 50%; padding-left: 20px">
                <div class="left-one-list-sj-num">
                  <span style="padding-right: 5px">{{ item.number }}</span>
                  <span style="font-size: 18px">{{ item.unit }}</span>
                </div>
                <span style="font-size: 14px">{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 病害知识库 -->
        <div class="left-two">
          <div class="title">病害知识库</div>
          <div class="left-duo" @click="bingShow = true;">查看更多</div>
          <div class="left-two-list">
            <el-carousel trigger="click" height="250px">
              <el-carousel-item v-for="(item, index) in bingList" :key="index">
                <div class="left-two-list-item">
                  <img @click="bingcDetail(item)" :src="item.icon" alt="" />
                  <div class="left-two-list-item-right">
                    <div><span>病害名称：</span>{{ item.name }}</div>
                    <div class="left-two-list-item-right-pestControl">
                      <span>防治措施：</span>{{ item.pestControl }}
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <!-- 农机专家 -->
        <div class="left-three">
          <div class="title">农机专家</div>
          <div class="left-duo" @click="njzjShow = true">查看更多</div>
          <div class="left-three-list">
            <vue-seamless-scroll
              :data="listData"
              :class-option="classOption"
              class="warp"
            >
              <ul class="ul-item">
                <li
                  @click="njzjDetail(item)"
                  class="li-item"
                  v-for="(item, index) in listData"
                  :key="index"
                >
                  <img :src="item.photos" alt="" />
                  <div
                    style="
                      width: 100%;
                      overflow: hidden;
                      white-space: nowrap;
                      text-overflow: ellipsis;
                    "
                  >
                    {{ item.posts }}
                  </div>
                  <div>{{ item.name }}</div>
                </li>
              </ul>
            </vue-seamless-scroll>
          </div>
        </div>
      </div>
      <!-- 中间 -->
      <div class="center">
        <!-- 产业数据统计 -->
        <div class="center-one">
          <div class="title" style="padding: 8px 0 0 45px">产业数据统计</div>
          <div class="center-one-list">
            <div
              v-for="(item, index) in itemList"
              :key="index"
              class="center-one-item"
            >
              <img :src="item.icon" alt="" />
              <div class="center-one-text">
                <div class="item-one-p">
                  {{ item.name }}
                </div>
                <div style="color: #409eff; font-size: 16px; font-weight: bold">
                  <span class="p-number" :style="{ color: colorss[index] }">{{
                    item.number
                  }}</span
                  >{{ item.company }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 品牌建设 -->
        <div class="center-two">
          <div class="title" style="padding: 12px 0 0 45px">品牌建设</div>
          <div class="center-two-list">
            <img
              class="center-two-item"
              v-for="(item, index) in ppjlList"
              :key="index"
              :src="item"
              alt=""
            />
          </div>
        </div>
        <!-- 产品价格 -->
        <div class="center-three">
          <div class="title" style="padding: 10px 0 0 50px">产品价格监测</div>
          <price
            style="height: 228px; margin-top: 10px"
            id="left-echarts-02"
          ></price>
        </div>
      </div>
      <!-- 右 -->
      <div class="right">
        <!-- 溯源 -->
        <div class="right-one">
          <div class="title">溯源</div>
          <div @click="traceabilityShow = true" class="right-duo">查看更多</div>
          <div style="height: 230px; width: 92%; margin: 25px auto 0">
            <el-carousel autoplay height="230px">
              <el-carousel-item
                class="carousels"
                v-for="(item, index) in cpsuYuan.slice(0, 5)"
                :key="index"
              >
                <img
                  style="cursor: pointer"
                  class="carousels-img"
                  id="carouselsImg"
                  :src="item.productImages"
                  alt=""
                />
                <img
                  @mouseenter="enter(item.qrCode)"
                  @mouseleave="leave(item.productImages)"
                  class="carousels-img3"
                  src="../../assets/cockpit/ewm.png"
                />
                <div
                  style="display: flex; flex-direction: column; font-size: 18px"
                >
                  <span style="color: #fff">产品名称：{{ item.name }}</span>
                  <span style="margin: 10px 0"
                    >生产厂家：{{ item.company }}</span
                  >
                  <el-button @click="suyuans" type="primary" small
                    >查看溯源</el-button
                  >
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <!-- 养殖种类 -->
        <div class="right-two">
          <div class="title">养殖种类</div>
          <statistics style="height: 250px; margin-top: 10px"></statistics>
        </div>
        <!-- 产品流通 -->
        <div class="right-three">
          <div class="title">产品流通</div>
          <div class="right-three-list">
            <div class="right-three-list-title">
              <div style="width: 33%; text-align: center">排名</div>
              <div style="width: 33%; text-align: center">名称</div>
              <div style="width: 33%; text-align: center">订单量</div>
            </div>
            <div class="right-three-list-item">
              <vue-seamless-scroll
                :class-option="classOptio2"
                :data="listData2"
                class="warp2"
              >
                <div
                  style="cursor: pointer"
                  class="left-echarts-box-list-box"
                  v-for="(item, index) in listData2"
                  :key="index"
                >
                  <span style="width: 33%; text-align: center">
                    <img :src="listData2Image[index]" alt="" />
                  </span>
                  <span style="width: 33%; text-align: center">{{
                    item.name
                  }}</span>
                  <span style="width: 33%; text-align: center"
                    >{{ item.number }}{{ item.unit }}</span
                  >
                </div>
              </vue-seamless-scroll>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 溯源过程 -->
    <div v-if="dialogVisible" class="suyuansss" @click="suyuanshow">
      <iframe
        src="http://43.137.43.240:19791/erwm?vcCutsNo=202405173534000012&orgcode=undefined&agribarcode=1"
        width="600"
        height="850"
        style="border-radius: 10px; z-index: 9998"
      >
        <p>Your browser does not support iframes.</p>
      </iframe>
    </div>
    <!-- 溯源弹出框 -->
    <el-dialog
      width="70%"
      title="溯源列表"
      :modal-append-to-body="false"
      :visible.sync="traceabilityShow"
    >
      <!-- 列表 -->
      <div
        class="chongqing-dialog2-conter"
        style="padding: 0 20px 20px 20px; box-sizing: border-box"
      >
        <div
          class="chongqing-dialog2-conter-list2"
          v-for="(item, index) in cpsuYuan"
          :key="index"
        >
          <img
            style="
              cursor: pointer;
              width: 150px !important;
              height: 180px !important;
              margin-right: 10px !important;
            "
            class="carousels-img"
            id="carouselsImg2"
            :src="item.productImages"
            alt=""
          />
          <img
            @mouseenter="enter2(item.qrCode)"
            @mouseleave="leave2(item.productImages)"
            class="carousels-img3"
            style="bottom: 28px; left: 60px"
            src="../../assets/cockpit/ewm.png"
          />
          <div style="display: flex; flex-direction: column; font-size: 16px">
            <span style="color: #fff">产品名称：{{ item.name }}</span>
            <span style="margin: 15px 0">生产厂家：{{ item.company }}</span>
            <el-button @click="suyuans" type="primary" small
              >查看溯源</el-button
            >
          </div>
        </div>
      </div>
      <!-- 分页 -->
      <div class="chongqing-dialog2-fenye">
        <el-pagination
          background
          layout="total , prev, pager, next , jumper"
          :total="sytotal"
          @current-change="handleCurrentChange3"
        >
        </el-pagination>
      </div>
    </el-dialog>
    <!-- 病虫害弹出框 -->
    <el-dialog
      width="70%"
      title="病害列表"
      :modal-append-to-body="false"
      :visible.sync="bingShow"
      @close="closeDialog"
    >
      <!-- 搜索 -->
      <div class="chongqing-dialog2">
        <el-input style="width: 400px" placeholder="请输入内容" v-model="name">
          <template slot="prepend">病害名称</template>
        </el-input>
        <!-- 搜索按钮 -->
        <el-button
          style="margin: 0 20px"
          icon="el-icon-search"
          type="primary"
          round
          @click="search"
          >搜索</el-button
        >
        <el-button @click="roott" icon="el-icon-refresh" round>重置</el-button>
      </div>
      <!-- 列表 -->
      <div class="chongqing-dialog2-conter">
        <div
          class="chongqing-dialog2-conter-list"
          v-for="(item, index) in bingList"
          :key="index"
        >
          <div style="color: #5dedf1">
            <i class="el-icon-cpu"></i> {{ item.name }}
          </div>
          <img
            @click="bingcDetail(item)"
            style="width: 100%; height: 160px; cursor: pointer"
            :src="item.icon"
            alt=""
          />
          <div class="chongqing-dialog2-conter-list-nr">
            <span style="color: #5dedf1">特征：</span>{{ item.dameage }}
          </div>
          <div class="chongqing-dialog2-conter-list-nr">
            <span style="color: #5dedf1">危害描述：</span>{{ item.description }}
          </div>
        </div>
      </div>
      <!-- 分页 -->
      <div class="chongqing-dialog2-fenye">
        <el-pagination
          background
          layout="total , prev, pager, next , jumper"
          :total="chongtotal"
          @current-change="handleCurrentChange2"
        >
        </el-pagination>
      </div>
    </el-dialog>
    <!-- 病虫害详情弹出框 -->
    <el-dialog
      title="病害详情"
      :modal-append-to-body="false"
      :visible.sync="bingDetailShow"
    >
      <div style="display: flex">
        <div>
          <div class="chongqing-dialog3-detsail">
            <span class="chongqing-dialog3-detsail-sp"
              ><i class="el-icon-cpu"></i> 名称</span
            >
            <span style="margin: 10px">{{ bingDetail.name }}</span>
          </div>
          <div class="chongqing-dialog3-detsail">
            <span class="chongqing-dialog3-detsail-sp"
              ><i class="el-icon-bangzhu"></i> 特征</span
            >
            <span style="margin: 10px">{{ bingDetail.description }}</span>
          </div>
          <div class="chongqing-dialog3-detsail">
            <span class="chongqing-dialog3-detsail-sp"
              ><i class="el-icon-warning-outline"></i> 危害描述</span
            >
            <span style="margin: 10px">{{ bingDetail.dameage }}</span>
          </div>
        </div>
        <img
          style="
            width: 300px;
            height: 300px;
            border-radius: 5px;
            margin-left: 20px;
          "
          :src="bingDetail.icon"
          alt=""
        />
      </div>
      <div class="chongqing-dialog3-detsail">
        <span class="chongqing-dialog3-detsail-sp"
          ><i class="el-icon-document"></i> 防治建议</span
        >
        <span style="margin: 10px">{{ bingDetail.pestControl }}</span>
      </div>
    </el-dialog>
    <!-- 农技专家弹出框 -->
    <el-dialog
      width="70%"
      title="农技专家"
      :modal-append-to-body="false"
      :visible.sync="njzjShow"
    >
      <!-- 列表 -->
      <div class="chongqing-dialog2-conter">
        <div
          class="chongqing-dialog2-conter-list"
          v-for="(item, index) in listData"
          :key="index"
        >
          <div
            style="
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            <img
              @click="njzjDetail(item)"
              style="width: 60%; height: 160px; cursor: pointer; display: flex"
              :src="item.photos"
              alt=""
            />
          </div>

          <div style="color: #5dedf1; padding: 10px 0">
            姓名：<span style="color: #fff">{{ item.name }}</span>
          </div>
          <div class="chongqing-dialog2-conter-list-nr">
            <span style="color: #5dedf1">研究方向：</span>{{ item.posts }}
          </div>
        </div>
      </div>
      <!-- 分页 -->
      <div class="chongqing-dialog2-fenye">
        <el-pagination
          background
          layout="total , prev, pager, next , jumper"
          :total="listData.length"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </el-dialog>
    <!-- 农技专家详情弹出框 -->
    <el-dialog
      title="农技专家详情"
      :modal-append-to-body="false"
      :visible.sync="listDataDetailShow"
    >
      <div style="display: flex">
        <div>
          <div class="chongqing-dialog3-detsail">
            <span class="chongqing-dialog3-detsail-sp"> 姓名</span>
            <span style="margin: 10px">{{ listDataDetail.name }}</span>
          </div>
          <div class="chongqing-dialog3-detsail">
            <span class="chongqing-dialog3-detsail-sp"> 研究方向</span>
            <span style="margin: 10px">{{ listDataDetail.posts }}</span>
          </div>
          <div class="chongqing-dialog3-detsail">
            <span class="chongqing-dialog3-detsail-sp"> 个人介绍</span>
            <span style="margin: 10px" v-html="listDataDetail.describes"></span>
          </div>
        </div>
        <img
          style="
            width: 300px;
            height: 300px;
            border-radius: 5px;
            margin-left: 20px;
          "
          :src="listDataDetail.photos"
          alt=""
        />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
// 养殖种类
import statistics from "../../components/cockpit/statistics.vue";
// 产品价格
import price from "../../components/cockpit/price.vue";
// 头部
import HeaderTitle from "../../components/HeaderTitle.vue";

export default {
  components: {
    HeaderTitle,
    statistics,
    price,
  },
  data() {
    return {
      title: "可视化驾驶舱",
      // 环境数据监测
      huanjingList: [
        {
          icon: require("../../assets/cockpit/kongqishidu.png"),
          number: "25.97",
          name: "空气温度",
          unit: "℃",
        },
        {
          icon: require("../../assets/cockpit/kongqiwendu.png"),
          number: "16",
          name: "空气湿度",
          unit: "℃",
        },
        {
          icon: require("../../assets/cockpit/eryanghuatan.png"),
          number: "500",
          name: "二氧化碳",
          unit: "ppm",
        },
        {
          icon: require("../../assets/cockpit/guangzhaoqiangdu.png"),
          number: "25.97",
          name: "光照强度",
          unit: "Lux",
        },
      ],
      // 病害数据
      bingList: [
        {
          icon: "https://img2.baidu.com/it/u=4134642994,4086215590&fm=253&fmt=auto&app=138&f=JPEG?w=618&h=399",
          name: "鸡球虫病",
          dameage:
            "病鸡精神沉郁，羽毛蓬松，头卷缩，食欲减退，嗉囊充满液体，鸡冠和可视黏膜贫血、苍白，逐渐消瘦，病鸡发病初期粪便为紫褐色，后期变为血粪，含有大量黏液和脱落的肠黏膜。",
          description:
            "鸡球虫病是鸡常见且危害十分严重的寄生虫病，它造成的经济损失惊人，雏鸡发病率和致死率均较高，不及时采取措施，致死率可达50%以上。病愈的雏鸡生长受阻、增重缓慢，成年鸡多为带虫者，但增重和产蛋能力降低。艾美耳原虫孢子变为卵囊后污染环境，鸡吞食了散布在土壤、草地、饲料和饮水等外界环境中的感染性卵囊就可引起发病。",
          pestControl:
            "加强饲养管理，保持鸡舍干燥、通风、干净。保持鸡场卫生，定期消毒和清除粪便，为了避免发生传染可将粪便堆放发酵以杀灭卵囊。成年鸡与雏鸡分开喂养，避免带虫的成年鸡散播病原导致雏鸡爆发球虫病。①笼具、料槽、水槽定期消毒，每周一次，可用沸水、热蒸汽或3%～5%的熱碱水等消毒处理。用球杀灵和1︰200的农乐溶液消毒鸡场及运动场，这些药物对球虫卵囊有强大杀灭作用。长期保持饲料、饮水清洁卫生。②免疫：用鸡胚传代致弱的虫株或早熟选育的致弱虫株给鸡免疫接种，可对球虫病产生很好的预防效果。",
        },
        {
          icon: "https://5b0988e595225.cdn.sohucs.com/images/20191231/3151eb8aa7304637ae0747b56d0d86bf.jpeg",
          name: "鸡呼吸道综合征",
          dameage:
            "传染源主要是病鸡和康复后带毒鸡，病鸡康复后可带毒50天。这些带毒鸡的飞沫经呼吸道排出，污染水源、饲料、槽具和垫料等。本病是由两种或两种以上致病因素相互作用而发生的一种病程漫长、病因复杂的鸡呼吸道疾病征侯群，临床表现为严重的继发或并发混合感染。本病传播迅速，一旦感染几乎全群发病。一年四季都可发生，寒冷季节较为多发，病程长达半月之久。",
          description:
            "潜伏期一般为18～36小时。临床表现严重的气喘、咳嗽，鼻腔、呼吸道内有大量分泌物，眼睛湿润肿胀，病鸡呆钝、食欲减退或废绝，拉白色水样粪便，冠髯及皮肤发绀，幼鸡死亡率高达60%。",
          pestControl:
            "改善饲养管理加强营养缓解病情，并在饲料中和饮水内添加维生素及微量元素等以增强鸡体的抗病力。①免疫接种：雏鸡阶段选用新城疫和传染性支气管炎二联苗，传染性支气管炎疫苗成年鸡可用H52活疫苗，雏鸡可用H120活疫苗，种鸡及产蛋鸡开产时用灭活油乳剂苗较好。一月后可加强免疫一次，种用鸡在2～4月龄加强免疫一次。接种时间、剂量要适当，各年龄段鸡均可迅速产生坚强的免疫力。",
        },
        {
          icon: "https://img1.baidu.com/it/u=2764298470,231087872&fm=253&fmt=auto&app=138&f=JPEG?w=563&h=314",
          name: "鸡新城疫",
          dameage: "鸡新城疫病毒感染。",
          description:
            "新城疫病引起的呼吸道症状较重，常发出呼噜声并常伴有结膜炎、鼻窦炎，临床仅表现为咳嗽、流涕，呼吸时发出“咯咯”声。头颈伸直，张口呼吸，拉水样绿色稀粪，病鸡逐渐脱水消瘦，呈慢性散发性死亡。",
          pestControl:
            "主要是以免疫接种预防感染，对症治疗继发感染。总之要控制好禽类疾病，加强饲养管理，改善养殖厂内外环境，提高鸡的抗病力是关键。合理布局鸡舍，降低鸡饲养密度，提高饲料营养水平，及时清除粪便、垃圾、垫料，加强通风换气，保证鸡舍内温度、湿度、光照相对稳定，注意饮水卫生，不喂发霉变质饲料。",
        },
      ],
      // 病害详情数据
      bingDetail:{},
      chongtotal:0,
      name:'',
      // 分页
      bingpage: {
        pageNum: 1,
        pageSize: 10,
      },
      // 病害弹出框显示隐藏
      bingShow:false,
      // 病害详情弹出框显示隐藏
      bingDetailShow:false,
      // 获取病害页数
      bing: {
        pageNum: 1,
        pageSize: 10,
        name: "鸡蛋",
      },
      classOption: {
        step: 0.5,
        direction: 3,
        limitMoveNum: 5,
      },
      // 农技专家数据
      listData: [
        {
          describes:
            '<p><span style="text-indent: 40px;"> 现任国家蛋鸡产业技术体系首席科学家、畜禽育种国家工程实验室主任、中国畜牧兽医学会动物遗传育种学分会理事长、国家畜禽遗传资源委员会副主任、全国畜禽遗传资源普查鸡专业组组长，曾任世界家禽学会主席（2016-2022）。国家杰出青年科学基金和国务院政府特殊津贴获得者、新世纪百千万人才工程国家级人选、全国农业科研杰出人才和“风鹏行动·种业功臣”。主要从事家禽重要经济性状遗传基础解析、家禽育种技术研究与新品种培育以及家禽生产技术体系研究与示范工作。先后获国家科技进步二等奖3项，国家技术发明二等奖1项，并荣获2019年“全国脱贫攻坚奖创新奖”。作为第一发明人获授权发明专利17项，编写专著11部，在 Nature、Molecular Biology and Evolution、Microbiome、ISME Journal、BMC Biology、PLoS Genetics等知名期刊发表学术论文300余篇。鉴定了绿壳蛋、鸡蛋鱼腥味、匍匐胫、红羽等一大批影响鸡重要性状的功能基因和分子标记，针对我国鸡育种主要核心群体，设计开发了我国首个具有自主知识产权的50K SNP芯片“凤芯壹号”，建立并应用以基因组选择为基础的第三代鸡育种技术体系，使我国鸡分子育种走到了国际前列。作为国内培育畜禽新品种数量最多的科学家，为我国家禽种业振兴作出了卓越贡献。先后培育出7个适合产业需求的蛋鸡新品种，为我国蛋鸡产业摆脱对国外品种的依赖、保障蛋鸡产业稳定发展发挥了战略支撑作用。</span></p>',
          id: 0,
          name: "杨宁",
          photos:
            "https://www.caaa.cn/uploadfile/2023/0313/thumb_98_136_20230313093208299.jpg",
          posts: "蛋鸡育种",
          achieve: "中国农业大学讲席教授，博士生导师。首席科学家",
        },
        {
          describes:
            '<p><span style="text-indent: 40px;">中国畜牧业协会副秘书长、蛋鸡业分会、白羽肉鸡业分会、黄羽肉鸡业分会、水禽业分会执行会长，猪业分会、鸽业分会、鹌鹑业分会秘书长；农业技术推广研究员；国务院特殊津贴专家，九届北京市政协委员等职务。先后从事家禽的遗传育种、饲养管理和饲料营养的研究和生产及行业协会的管理和服务等工作。曾参加和亲自主持了国家“六五”、“七五”、“八五”、“九五”四个五年家禽的育种攻关及其他省部级科研和高新生物技术、计算机育种软件应用研究、科研成果、推广等项目20余项。先后育成了我国优秀的“京白”系列蛋鸡各类纯系27个，配套系近20个。填补了我国蛋鸡良种的空白。先后获得国家星火一等奖；国家科技进步二等奖（2项）；北京市科技进步及星火科技一等奖（多项）、农业部丰收二等奖等省部级以上奖项30多项。发表的各类研究文章等百余篇；撰写各类科研方案、规划、报告、论文等100多篇。荣获“国家星火先进个人”；“全国优秀科技工作者”；“全国五一劳动奖章”；首都劳动奖章；首都爱国立功标；行业突出贡献奖等荣誉称号20多项。2019年荣获中共中央、国务院，中央军委授予的“庆祝中华人民共和国成立70周年纪念章”。</span></p>',
          id: 1,
          name: "宫桂芬",
          photos:
            "https://www.caaa.cn/uploadfile/2023/0313/thumb_98_136_20230313014547197.jpg",
          posts: "蛋鸡",
          achieve: "中国畜牧业协会副秘书长",
        },
        {
          describes:
            '<p><span style="text-indent: 40px;">国家家禽测定中心副主任，农业部家禽品质监督检验测试中心副主任，国家蛋鸡产业技术体系岗位科学家。长期从事家禽遗传育种与生产研究，尤其在蛋鸡育种和产业 化方面成绩突出。作为主创研究人员，成功培育出了农大3号、农大5号、大午金凤、大午褐、容德小黑鸡等蛋鸡品种，尤其具有高饲料转化效率的“农大 3 号节粮小型蛋鸡”，2015年获得国家科技进步二等奖。大午金凤开创了世界上红羽鸡产粉壳蛋的先例，获得2018年河北省科技进步一等奖。先后获得国家奖2次，省部级奖10次 。2007 年获得农业部 全国农业科技推广标兵称号， 2008 年获得科技部全国优秀 科技特派员称号。2009 年首都十大教育新闻人物，北京市农 业科技十佳称号。率领科研团队在蛋鸡特色育种和蛋鸡产业化健康养殖方面开展工作，成功进行了高 产蛋鸡放养技术的集成，已在国内外学术期刊发表学术论文 100 余篇，出版著作15部，销售量达到50万册，为基层养殖户授课达到 20 万人次。</span></p>',
          id: 2,
          name: "宁中华",
          photos:
            "https://www.caaa.cn/uploadfile/2023/0313/thumb_98_136_20230313094911227.png",
          posts: "蛋鸡育种",
          achieve: "中国农业大学教授、博士生导师。",
        },
        {
          describes:
            '<p><span style="text-indent: 40px;">陕西周至人，农学（动物营养与饲料科学）博士，中国农业科学院饲料研究所二级研究员、博士生导师。自1983年起一直在中国农业科学院工作，曾任饲料研究所副所长、所长。现兼任全国动物营养指导委员会委员兼蛋鸡营养分会负责人、中国畜牧兽医学会动物营养学分会副理事长、全国饲料评审委员会委员、全国饲料工业标准化技术委员会委员，《动物营养学报》常务副主编，《Poultry Science》、《Animal Nutrition》、《中国畜牧杂志》、《中国家禽》、《中国饲料》、《饲料工业》等杂志编委。2009-2021年担任国家现代农业（蛋鸡）产业技术体系营养调控岗位科学家。获国家科技进步二等奖1次、省部级奖7次。其中，主持的“优质鸡蛋生产的营养调控技术体系创新与应用”获神农中华农业科技奖一等奖,并被遴选为“2020年中国农业农村重大新技术”和“2020年中国农科院十大科技进展”。以第一或通讯作者发表论文300余篇（其中SCI收录120余篇），出版书籍20多部（册）。累计培养博士10余名、硕士50余名。</span></p>',
          id: 3,
          name: "齐广海",
          photos:
            "https://www.caaa.cn/uploadfile/2023/0313/thumb_98_136_20230313020340804.png",
          posts: "蛋鸡营养",
          achieve: "中国农业科学院饲料研究所二级研究员、博士生导师。",
        },
        {
          describes:
            '<p><span style="text-indent: 40px;">研究员，湖北省农科院畜牧兽医研究所家禽研究室主任，国家蛋鸡产业技术体系武汉综合试验站站长、第四届国家畜禽遗传资源委员会委员、湖北省有突出贡献中青年专家。主要从事家禽遗传育种与健康养殖技术研究工作，先后承担省部级以上科研项目五十余项，培育出4个家禽新品种：湖北红鸡、金水乌鸡、“神丹1号”蛋用鹌鹑、“农湖2号”蛋鸭，获湖北省科技进步一等奖3项。</span></p>',
          id: 4,
          name: "皮劲松",
          photos:
            "https://www.caaa.cn/uploadfile/2023/0315/thumb_98_136_20230315085808744.jpg",
          posts: "蛋鸡育种",
          achieve: "湖北省农科院畜牧兽医研究所家禽研究室主任",
        },
      ],
      // 农技专家详情
      listDataDetail:{},
      njzjpage: {
        pageNum: 1,
        pageSize: 10,
      },
      // 农技专家详情弹出框显示隐藏
      listDataDetailShow: false,
      // 农技专家弹出框显示隐藏
      njzjShow:false,
      // 产业数据统计
      itemList: [
        {
          icon: require("../../assets/cockpit/ltqy.png"),
          name: "龙头企业",
          number: "16",
          company: "家",
        },
        {
          icon: require("../../assets/cockpit/hzs.png"),
          name: "合作社",
          number: "16",
          company: "家",
        },
        {
          icon: require("../../assets/cockpit/zzry.png"),
          name: "企业人员",
          number: "251",
          company: "人",
        },
        {
          icon: require("../../assets/cockpit/zzmj.png"),
          name: "企业面积",
          number: "5000",
          company: "亩",
        },
        {
          icon: require("../../assets/cockpit/ncl.png"),
          name: "年产量",
          number: "45200",
          company: "吨",
        },
        {
          icon: require("../../assets/cockpit/ncz.png"),
          name: "年产值",
          number: "48",
          company: "亿元",
        },
      ],
      // 产业数据统计背景色
      colorss: [
        "#f9d456",
        "#c26afc",
        "#43cb97",
        "#f56281",
        "#e09151",
        "#56bffa",
      ],
      // 品牌建设
      ppjlList: [
        "https://zhengxin-pub.cdn.bcebos.com/mark/3c80713e4dea53bcfaa0b5365d8f65b9.jpg",
        "https://tm-image.tianyancha.com/tm/46842a4ac08b26766d97dde5b105bdf9.jpg",
        "https://img.zcool.cn/community/016bd2591eac1da801216a3ebb0f74.jpg?x-oss-process=image/auto-orient,1/resize,m_lfit,w_1280,limit_1/sharpen,100/quality,q_100",
        "https://img.zcool.cn/community/01ca71591eacd2b5b3086ed47b14dc.jpg@1280w_1l_2o_100sh.jpg",
      ],
      // 产品溯源
      cpsuYuan: [
        {
          company: "美绿思生态农牧科技馆陶有限公司",
          createBy: null,
          createTime: null,
          id: 1,
          name: "馆陶鸡蛋",
          productImages:
            "https://img0.baidu.com/it/u=1348180828,209607036&fm=253&fmt=auto&app=138&f=JPEG?w=400&h=400",
          qrCode: require("../../assets/cockpit/ewm2.png"),
          remark: null,
          remarks: null,
          traceabilityFrequency: "1193次",
          updateBy: null,
          updateTime: null,
        },
      ],
      // 产品流通
      listData2: [
        {
          name: "河南",
          number: "7800",
          unit: "吨",
        },
        {
          name: "北京",
          number: "7500",
          unit: "吨",
        },
        {
          name: "天津",
          number: "7200",
          unit: "吨",
        },
        {
          name: "河北",
          number: "7000",
          unit: "吨",
        },
        {
          name: "长春",
          number: "6800",
          unit: "吨",
        },
      ],
      // 产品流通顺序
      listData2Image: [
        require("../../assets/cockpit/TOP1.png"),
        require("../../assets/cockpit/TOP2.png"),
        require("../../assets/cockpit/TOP3.png"),
        require("../../assets/cockpit/TOP4.png"),
        require("../../assets/cockpit/TOP5.png"),
        require("../../assets/cockpit/TOP6.png"),
        require("../../assets/cockpit/TOP7.png"),
        require("../../assets/cockpit/TOP8.png"),
        require("../../assets/cockpit/TOP9.png"),
        require("../../assets/cockpit/TOP10.png"),
      ],
      classOptio2: {
        step: 0.5,
      },
      // 溯源
      dialogVisible: false,
      // 溯源
      traceabilityShow: false,
      // 溯源
      sypage: {
        pageNum: 1,
        pageSize: 10,
      },
      sytotal:0,
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 获取病害数据
    getBingList() {
      axios({
        method: "get",
        url: "http://119.45.205.69:19789/yunying/KnPest/openapi/getList",
        params: {
          pageNum: this.bing.pageNum,
          pageSize: this.bing.pageSize,
          name: this.bing.name,
        },
      }).then((res) => {
        console.log("病害数据", res);
      });
    },
    // 专家详情
    njzjDetail(item) {
      this.listDataDetailShow = true;
      this.listDataDetail = item;
    },

    // 病害详情
    bingcDetail(item) {
      this.bingDetailShow = true;
      this.bingDetail = item;
      // console.log("病害详情", item);
    },
    // 溯源鼠标移入
    enter(val) {
      document.querySelector("#carouselsImg").src = val;
    },
    // 溯源鼠标移出
    leave(val) {
      document.querySelector("#carouselsImg").src = val;
    },
    // 鼠标移入
    enter2(val) {
      document.querySelector("#carouselsImg2").src = val;
    },
    // 鼠标移出
    leave2(val) {
      document.querySelector("#carouselsImg2").src = val;
    },
    // 溯源链条显示隐藏
    suyuans() {
      this.dialogVisible = true;
    },
    // 溯源链条显示隐藏
    suyuanshow() {
      this.dialogVisible = false;
    },
    // 搜索
    search() {
      console.log("搜索");
    },
    // 重置
    roott() {
      this.name = "";
      // this.bingList = [];
      console.log("重置");
    },
    // 虫情数据分页
    handleCurrentChange2(val) {
      this.name = "";
      // this.bingList = [];
      this.bingpage.pageNum = val;
    },
    // 农技专家分页
    handleCurrentChange(val) {
      // this.bingList = [];
      this.njzjpage.pageNum = val;
    },
    // 溯源分页
    handleCurrentChange3(val) {
      // this.bingList = [];
      this.sypage.pageNum = val;
    },
  },
};
</script>

<!-- 弹出框样式 -->
<style lang="scss" scoped>
  ::v-deep .el-dialog {
  background-color: #1a2042 !important;
  background-image: url("../../assets/cockpit/center.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  margin-top: 10vh !important;
}

::v-deep .el-dialog__title {
  color: #fff !important;
  font-size: 20px;
  font-weight: 600;
}

::v-deep .el-dialog__header {
  border-bottom: 1px solid #333;
}

::v-deep .el-dialog__body {
  color: #fff !important;
}

::v-deep .chongqing-dialog1 .el-date-editor .el-range-input {
  background-color: #000c1b;
  color: #fff;
}

::v-deep .chongqing-dialog1 .el-input__inner {
  color: #fff;
  background-color: #000c1b;
  border: 0;
}

::v-deep .chongqing-dialog1 .el-date-editor .el-range-separator {
  color: #fff;
}

::v-deep .chongqing-dialog1 .el-date-editor .el-range-separator {
  width: 10%;
  line-height: 35px;
}

::v-deep .chongqing-dialog1 .el-date-editor .el-range__icon {
  line-height: 38px;
}

::v-deep .chongqing-dialog2 .el-input-group__prepend {
  color: #fff;
  background-color: #000c1b;
  border: 1px solid #043b78;
}

::v-deep .chongqing-dialog2 .el-input__inner {
  color: #fff;
  background-color: #000c1b;
  border: 1px solid #043b78;
}
</style>

<style lang="scss" scoped>
::v-deep .el-carousel__button {
  height: 3px;
}
::v-deep .el-carousel__arrow {
  display: none !important;
}
.warp {
  width: 100%;
  height: 100%;
  margin: auto 0;
  overflow: hidden;
}
#views-page1 {
  box-sizing: border-box;
  background: url(~@/assets/background-img.png) no-repeat center center;
  background-size: 100% 100%;
  width: 1920px;
  height: 1080px;
  overflow: hidden;
}
// 内容
.content {
  color: #fff;
  width: 100%;
  height: 90%;
  box-sizing: border-box;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // 左
  .left {
    width: 28%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    // 环境数据监测
    .left-one {
      width: 100%;
      height: 30%;
      background-image: url("../../assets/cockpit/back-1.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .left-one-list {
        margin: 10px 0;
        height: 80%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        flex-wrap: wrap;
        box-sizing: border-box;

        .left-one-list-sj {
          background-color: #00253f;
          width: 47%;
          margin-top: 10px;
          height: 40%;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: center;

          &:nth-child(odd) {
            border-top: 3px solid #00798e;
          }

          &:nth-child(even) {
            border-top: 3px solid #8c4c60;
          }

          .left-one-list-sj-tp {
            background: url(~@/assets/cockpit/yuan.png) no-repeat center center;
            background-size: 100% 100%;
            width: 60px;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: space-around;
          }
          .left-one-list-sj-num {
            font-size: 20px;
            letter-spacing: 1px;
            font-weight: 900;
            background: linear-gradient(to bottom, #ffffff, #64c3ff);
            -webkit-background-clip: text !important;
            background-clip: text;
            color: transparent;
          }
        }
      }
    }
    // 病害知识库
    .left-two {
      width: 100%;
      height: 33%;
      background-image: url("../../assets/cockpit/back-5.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      position: relative;
      .left-duo {
        position: absolute;
        right: 20px;
        top: 10px;
        padding: 7px 20px;
        letter-spacing: 2px;
        cursor: pointer;
        background-image: url("../../assets/cockpit/duo.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
      .left-two-list {
        width: 98%;
        margin: 20px auto 0;
        height: 79%;
        .left-two-list-item {
          display: flex;
          justify-content: space-between;
          width: 100%;
          height: 100%;
          img {
            width: 50%;
            height: 90%;
            display: block;
            border: 3px solid #0092d8;
            border-radius: 5px;
            cursor: pointer;
          }
          .left-two-list-item-right {
            width: 48%;
            height: 90%;
            overflow: hidden;
            div {
              span {
                &:nth-child(1) {
                  color: #0292d6;
                  font-weight: 600;
                }
              }
            }
            .left-two-list-item-right-pestControl {
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 9;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
    // 农技专家
    .left-three {
      width: 100%;
      height: 33%;
      background-image: url("../../assets/cockpit/back-5.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      position: relative;
      .left-duo {
        position: absolute;
        right: 20px;
        top: 10px;
        padding: 7px 20px;
        letter-spacing: 2px;
        cursor: pointer;
        background-image: url("../../assets/cockpit/duo.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
      .left-three-list {
        width: 98%;
        margin: 15px auto 0;
        height: 250px;
        cursor: pointer;
        // 农技专家
        ul {
          width: 100%;
          height: 100%;
          list-style: none;
          padding: 0;
          margin: 0 auto;
          display: flex;
        }

        .li-item {
          width: 130px;
          height: 240px;
          margin-right: 10px;
          /* line-height: 120px; */
          color: #fff;
          text-align: center;
          font-size: 18px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-around;
        }

        .li-item img {
          width: 100%;
          height: 176px;
          border: 5px solid #3899da;
          border-radius: 5px;
          margin-top: 12px;
        }
      }
    }
  }
  // 中间
  .center {
    width: 42%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    // 产业数据统计
    .center-one {
      width: 100%;
      height: 43%;
      background-image: url("../../assets/cockpit/back-3.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .center-one-list {
        width: 100%;
        height: 80%;
        margin: 30px auto 0;
        display: flex;
        flex-wrap: wrap;
        .center-one-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          box-sizing: border-box;
          width: 33.33%;
          text-align: center;
          .item-one-p {
            font-weight: bold;
            font-size: 16px;
            padding: 5px 20px;
            border-radius: 14px;
            margin: 5px 0;
            background-color: #00a0ea;
          }
          .center-one-text {
            display: inline-block;
          }
          .p-number {
            font-size: 30px;
            font-weight: bold;
            letter-spacing: 3px;
          }
        }
      }
    }
    // 品牌建设
    .center-two {
      width: 100%;
      height: 25%;
      background-image: url("../../assets/cockpit/back-7.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .center-two-list {
        height: 80%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .center-two-item {
          width: 130px;
          height: 130px;
          border-radius: 50%;
          object-fit: cover;
        }
      }
    }
    // 价格监测
    .center-three {
      width: 100%;
      height: 30%;
      background-image: url("../../assets/cockpit/back-1.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
  // 右
  .right {
    width: 28%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    // 溯源
    .right-one {
      width: 100%;
      height: 33%;
      background-image: url("../../assets/cockpit/back-6.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      position: relative;
      .right-duo {
        position: absolute;
        right: 20px;
        top: 10px;
        padding: 7px 20px;
        letter-spacing: 2px;
        cursor: pointer;
        background-image: url("../../assets/cockpit/duo.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
      .carousels {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 200px;
        width: 100%;
        position: relative;
        margin-top: 10px;
      }
    }
    // 产品产量
    .right-two {
      width: 100%;
      height: 32.5%;
      background-image: url("../../assets/cockpit/back-1.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    // 产品流通
    .right-three {
      width: 100%;
      height: 32.5%;
      background-image: url("../../assets/cockpit/back-1.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .right-three-list {
        width: 96%;
        margin: 15px auto 0;
        height: 80%;
        .right-three-list-title {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-around;
          border: 1px solid #0092d8;
          div {
            padding: 5px 0;
          }
        }
        .right-three-list-item {
          width: 100%;
          height: 210px;
          .warp2 {
            width: 100%;
            height: 100%;
            margin: auto 0;
            overflow: hidden;
            .left-echarts-box-list-box {
              display: flex;
              align-items: center;
              justify-content: space-between;
              height: 40px;
              background-color: #0a2f593f;
              border: 1px solid #1c4065;
            }
          }
        }
      }
    }
  }
}
// 模块标题
.title {
  font-size: 20px;
  letter-spacing: 2px;
  font-weight: bold;
  background: linear-gradient(to bottom, #ffffff, #a3dcff);
  -webkit-background-clip: text !important;
  background-clip: text;
  color: transparent;
  padding: 13px 0 0 40px;
}

// 溯源链条
.suyuansss {
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.271);
  width: 100%;
  height: 100%;
  z-index: 9997;
  display: flex;
  align-items: center;
  justify-content: center;
}
// 分页
.chongqing-dialog2-fenye {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
// 溯源
.carousels-img {
  width: 140px;
  height: 160px;
  border: 3px solid #03bbf6;
  border-radius: 5px;
  margin-right: 30px;
  display: block;
}
.carousels-img2 {
  width: 140px;
  height: 160px;
  border: 3px solid #03bbf6;
  border-radius: 5px;
  margin-right: 30px;
  display: block;
}
.carousels-img3 {
  width: 30px;
  height: 30px;
  position: absolute;
  bottom: 7px;
  left: 58px;
  border: 3px solid #03bbf6;
  border-radius: 50%;
  cursor: pointer;
}
.chongqing-dialog2-conter-list2 {
  width: 33%;
  height: 260px;
  position: relative;
  display: flex;
  align-items: center;
}
.chongqing-dialog2-conter {
  height: 560px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 30px;
}
// 农技专家
.chongqing-dialog2-conter-list-nr {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.chongqing-dialog2-conter-list {
  width: 20%;
  height: 280px;
  padding: 10px;
  box-sizing: border-box;
}
.chongqing-dialog3-detsail {
  display: flex;
  flex-direction: column;
  margin: 0 20px;
  width: 100%;
  font-size: 18px;
}

.chongqing-dialog3-detsail-sp {
  background: linear-gradient(to right, #1c46a5, #1c45a500);
  border-radius: 30px;
  width: 200px;
  height: 30px;
  line-height: 30px;
  padding-left: 20px;
}

// 病虫害知识库

</style>
